module.exports = __webpack_public_path__ + "img/seo_background_greyscale.1f9057d7.jpg";